import TripDetails from "../../Components/Trips/TripDetails";
import "../../Components/Style/Trips/TripsShow.css"

const TripsShow = () => {
  return (
    <div className="trips-show-pages">
      <TripDetails />
    </div>
  );
};

export default TripsShow;
